// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"2f4f4e6e","787":"fa9014fd"}[chunkId] + ".chunk.js";
};